<template>
  <div>
    <v-toolbar
      app
      :clipped-left="true"
      dark
      flat
      dense
      color="primary"
      class="main-nav-bar"
      style="color: rgba(255,255,255,.85); background-color: rgb(0, 94, 166) !important;"
    >
      <v-toolbar-side-icon @click.stop=""/>

      <v-toolbar-title v-text="appTitle"/>
      <v-spacer/>

      <v-toolbar-items>
        <v-btn
          flat
          dark
          @click="$router.push('/login')"
        >
          登录
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid grid-list-xl>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm8 md7 lg5 xl4>
            <v-card>
              <v-toolbar flat dark color="light-blue lighten-2">
                <v-icon>person</v-icon>
                <v-toolbar-title style="font-size: 16px;">通过邮箱找回密码</v-toolbar-title>
              </v-toolbar>
              <v-alert
                :type="msgType"
                :value="showMessage"
                style="margin: 0;border-color: transparent !important;"
              >
                {{message}}
              </v-alert>
              <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>
              <v-card-text>
                <v-form v-model="form" ref="form" lazy-validation>
                  <v-container fluid grid>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="企业信用代码"
                          v-model="item.creditCode"
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="电子邮箱"
                          v-model="item.email"
                          :rules="rules.email"
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions >
                <v-btn color="primary" flat @click="onApp">忘记邮箱密码，人工找回密码？</v-btn>
                <v-spacer></v-spacer>
                <v-btn  color="warning" :disabled="loading" @click="getEmail">查询邮箱</v-btn>
                <v-btn color="info" :disabled="loading" @click="onRegister">发送密码</v-btn>
                <v-btn color="success" :disabled="loading" to="/login">返回登录页</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      v-on:ok="onEditOk"
    />
  </div>
</template>
<script>
  import XEdit from '@/components/task/Password/Edit'

  export default {
    components: {XEdit},
    data() {
      return {
        loading: false,
        url: "/api/login/forget/password",

        form: false,
        item: {
          email: ''
        },

        msgType: 'error',
        message: '输入注册时使用的邮箱地址，点击“找回密码”按钮找回用户密码。如忘记注册邮箱，输入组织结构代码，点击“查询邮箱”查询邮箱地址。',

        edit: false,
        editDbid: null,

        rules: {
          email: [
            v => !!v || '必填项。',
            v => (!v || /^[\w.\-_]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/ig.test(v)) || '邮箱格式不正确。',
            v => (v && v.length < 50) || "长度不能超过 50 个字符。"
          ],
          required: [
            v => !!v || '必填项。'
          ]
        }
      }
    },
    created() {
    },
    computed: {
      appTitle() {
        return document.title;
      },
      showMessage() {
        return this.message && this.message.length > 0;
      }
    },
    methods: {
      onApp() {
        const vm = this;
        vm.editDbid = null;
        vm.edit = true;
      },

      onEditOk(data){
        const vm = this;
        vm.message = data.message;
        vm.msgType = data.success === 'true' ? 'info' : 'error';
      },

      getEmail(){
        let getEmailUri = '/api/login/forget/getEmail'
        this.loading = true
        if(!this.item.creditCode){
          this.loading = false
          this.message = '请输入组织机构代码，查询邮箱地址！'
          this.msgType = 'error'
          return
        }
        this.axios.get(getEmailUri,{params:{"creditCode":this.item.creditCode}})
          .then(
            rsp => {
              this.loading= false
              let email = rsp.data.email
              if(email)
                this.item.email = email

              this.message = email ? '邮件地址获取成功，点击“发送密码”获取用户密码信息！如需要更换邮箱，请通过“人工找回”修改注册邮箱。' : '该组织机构代码未使用，获取邮箱失败';
              this.msgType = email ? 'info' : 'error';

            }
          )

      },

      onRegister() {
        if(!this.item.email){
          this.loading = false
          this.message = '请输入邮箱地址，如忘记邮箱地址请输入组织机构代码，并点击“查询邮箱”查询邮箱地址！'
          this.msgType = 'error'
          return
        }
        if (this.$refs.form.validate()) {
          const vm = this;
          vm.message = '';
          vm.loading = true;
          this.loading = true
          this.axios.post(this.url, this.item)
            .then(
              rsp => {
                vm.loading = false;
                vm.message = rsp.data.message;
                vm.msgType = rsp.data.success === 'true' ? 'info' : 'error';
                //vm.$router.push("/login");
              })
            .catch(err => {
              vm.loading = false;
            })
        }
      }
    }
  }
</script>

<style>
  main div.content--wrap {
    padding: 1rem;
  }

  .container.grid-list-xl .layout .flex {
    padding: 0 12px;
  }

  .main-nav-bar {
    border-bottom-color: rgba(0, 0, 0, 0.12);
    border-bottom-width: 2px;
    border-bottom-style: solid;
  }

</style>



// WEBPACK FOOTER //
// src/components/Forget.vue